import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=0234cf7a&scoped=true&"
import script from "./FooterLinks.vue?vue&type=script&lang=js&"
export * from "./FooterLinks.vue?vue&type=script&lang=js&"
import style0 from "./FooterLinks.vue?vue&type=style&index=0&id=0234cf7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0234cf7a",
  null
  
)

export default component.exports